<mat-form-field class="filter-input">
    <mat-label>{{ 'files.list.filter.shortLabel' | translate }}</mat-label>
    <input matInput (keyup)="onApplyFilter($event.target.value)">
</mat-form-field>

<table mat-table [dataSource]="dataSource" matSort multiTemplateDataRows>
    <ng-container matColumnDef="name">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>
            {{ 'files.list.name.shortLabel' | translate }} </th>
        <td mat-cell *matCellDef="let file;"> {{ file.name }} </td>
    </ng-container>

    <ng-container matColumnDef="organism">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>
            {{ 'files.list.organism.shortLabel' | translate }} </th>
        <td mat-cell *matCellDef="let file;"> {{ file.organism?.text?.shortLabel }} </td>
    </ng-container>

    <ng-container matColumnDef="partitioning">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>
            {{ 'files.list.partitioning.shortLabel' | translate }} </th>
        <td mat-cell *matCellDef="let file;"> {{ file.partitioning?.text?.shortLabel }} </td>
    </ng-container>

    <ng-container matColumnDef="type">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>
            {{ 'files.list.type.shortLabel' | translate }} </th>
        <!-- <td mat-cell *matCellDef="let file;"> {{ file.amountType?.text?.shortLabel }} </td> -->
        <td mat-cell *matCellDef="let file;"> {{ file.amountType }} </td>
    </ng-container>

    <ng-container matColumnDef="year">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>
            {{ 'files.list.year.shortLabel' | translate }} </th>
        <td mat-cell *matCellDef="let file;"> {{ file.year }} </td>
    </ng-container>

    <ng-container matColumnDef="editedOn">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>
            {{ 'files.list.editedOn.shortLabel' | translate }} </th>
        <td mat-cell *matCellDef="let file;"> {{ file.editedOn | date }} </td>
    </ng-container>

    <ng-container matColumnDef="uploadedBy">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>
            {{ 'files.list.uploadedBy.shortLabel' | translate }} </th>
        <td mat-cell *matCellDef="let file;"> {{ file.uploadedBy }} </td>
    </ng-container>

    <ng-container matColumnDef="uploadedOn">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>
            {{ 'files.list.uploadedOn.shortLabel' | translate }} </th>
        <td mat-cell *matCellDef="let file;"> {{ file.uploadedOn | date }} </td>
    </ng-container>

    <ng-container matColumnDef="status">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>
            {{ 'files.list.status.shortLabel' | translate }} </th>
        <td mat-cell *matCellDef="let file;">
            <span class="success" *ngIf="file.status === processState.success">
                <mat-icon aria-label="Check">check</mat-icon>
                {{ 'files.processingStates.success.shortLabel' | translate }}
            </span>
            <span class="fail" *ngIf="file.status === processState.fail">
                <mat-icon aria-label="Close">close</mat-icon> {{ 'files.processingStates.fail.shortLabel' | translate }}
            </span>
            <span class="process" *ngIf="file.status === processState.processing && file.uploadedOn === '0001-01-01T00:00:00'">
                {{ 'files.processingStates.waiting.fullLabel' | translate }}
            </span>
            <span class="process" *ngIf="file.status === processState.waiting">
                {{ 'files.processingStates.waiting.fullLabel' | translate }}
            </span>
            <span class="process" *ngIf="file.status === processState.processing && file.uploadedOn !== '0001-01-01T00:00:00'">
                {{ 'files.processingStates.processing.shortLabel' | translate }}
            </span>
            <button mat-icon-button *ngIf="file.errors && file.errors.length" (click)="onToggleSelected(file.id)">
                <mat-icon aria-label="Details">{{ showedId === file.id ? 'zoom_out' : 'zoom_in' }}</mat-icon>
            </button>
        </td>
    </ng-container>

    <ng-container matColumnDef="dataDate">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>
            {{ 'Date des données' }} </th>
        <td mat-cell *matCellDef="let file;"> {{ file.uploadedOn === '0001-01-01T00:00:00' ? '' : file.uploadedOn | date }} </td>
    </ng-container>
    <ng-container matColumnDef="importDate">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>
            {{ 'Importé le' }} </th>
        <td mat-cell *matCellDef="let file;"> {{ file.editedOn | date }} </td>
    </ng-container>

    <ng-container matColumnDef="actions">
        <th mat-header-cell *matHeaderCellDef> {{ 'files.list.actions.shortLabel' | translate }} </th>
        <td mat-cell *matCellDef="let file;">
            <button mat-icon-button class="action-button" color="accent"
                [disabled]="isLoading || file.status === processState.waiting || file.status === processState.processing || (file.uploadedBy !== user.name && user.role !== RoleType.admin)"
                [matTooltip]="'files.list.delete.summary' | translate" (click)="onDeleteFile(file.id)">
                <mat-icon aria-label="Edit">delete</mat-icon>
            </button>
        </td>
    </ng-container>

    <ng-container matColumnDef="expandedDetail">
        <td mat-cell *matCellDef="let file;" [attr.colspan]="displayedColumns.length">
            <div *ngIf="file.id === showedId" class="file-detail"
                [@detailExpand]="file.id === showedId ? 'expanded' : 'collapsed'">
                <mat-list>
                    <mat-list-item class="error-item" *ngFor="let error of file.errors">
                        <mat-icon mat-list-icon class="fail">close</mat-icon>
                        <span class="label">{{ error.errorMessage }}</span>
                    </mat-list-item>
                </mat-list>
            </div>
        </td>
    </ng-container>

    <ng-container matColumnDef="paginator">
        <td mat-footer-cell *matFooterCellDef colspan="99">
          <mat-paginator [pageSizeOptions]="[10,20,50]" showFirstLastButtons></mat-paginator>
        </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row class="file-row" *matRowDef="let row; columns: displayedColumns;"
        [ngClass]="{'expanded-row': row.id === showedId}"></tr>
    <tr mat-row *matRowDef="let row; columns: ['expandedDetail']" class="detail-row"></tr>

    <tr mat-footer-row *matFooterRowDef="['paginator']"></tr>
</table>
